import { useParams, useLocation, Link } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import CourseCockpitSection from "../components/CourseCockpitSection";
import { PaperGradientBG } from "../kits";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const CourseCockpitUser = () => {
  const { courseId } = useParams();
  const { userId } = useAuth();
  const query = useQuery();
  const location = useLocation();
  const courseTitle = location.state?.title;

  const registrationId = query.get("registration");

  if (!userId || !courseId || !registrationId)
    return (
      <PaperGradientBG variant="zenBlack">
        <div className="min-h-screen flex items-center justify-center">
          <p className="text-xs text-[#EFEBDC]/40 font-mono">
            <span className="text-[#AC8E66]/60">&gt;</span> lade kurs-cockpit...
          </p>
        </div>
      </PaperGradientBG>
    );

  return (
    <PaperGradientBG variant="zenBlack">
      <div className="min-h-screen">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 py-8 font-mono">
          <CourseCockpitSection
            userId={parseInt(userId)}
            courseId={parseInt(courseId)}
            registrationId={parseInt(registrationId)}
            courseTitle={courseTitle}
          />

          <div className="mt-8">
            <Link to="/dashboard">
              <button className="w-full py-2.5 text-xs font-mono text-[#AC8E66] bg-[#1c1c1c] border border-[#AC8E66]/30 rounded hover:border-[#AC8E66]/60 hover:bg-[#1e1e1e] transition-all cursor-pointer">
                [ zurueck zum dashboard → ]
              </button>
            </Link>
          </div>
        </div>
      </div>
    </PaperGradientBG>
  );
};

export default CourseCockpitUser;
